import { Table, Pagination } from "antd";
import React, {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {
  Avatar_01,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
  Avatar_11,
  Avatar_12,
  Avatar_13,
  Avatar_16,
  eye,
  laptop,
} from "Routes/ImagePath";
import Select from "react-select";
import { getAssetsApi } from "api/services/employee";
import {itemRender, handlePageChange, defaultPagination, pageSizeOptions} from "utils/table";
import { formatDateHandler2 } from "utils/common";
import { useMediaQuery } from "react-responsive";
import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";
import Image from "components/Image";



const Assets = ({userData}) => {
  
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
const [view, setView] = useState(isMobile? "grid":"list");


  const [assets, setAssets] = useState([])
  const [loading, setLoading] = useState(false)
  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
      sortType: "asc",
      sortBy: "asset__name"
    })

  useEffect(()=>{
    console.log(userData, "USERRRRRR")
    if(userData?.id){
      let params = {
        user: userData?.id,
        sort_by: pageSettings?.sortBy,
        sort_type: pageSettings?.sortType,
        page_size: pageSettings?.pageSize,
        page: pageSettings?.page,
        company_user: userData?.id,

    }
    setLoading(true)
    getAssetsApi(params).then(response=>{
        setAssets(response.data.results)
        setLoading(false)
        setPageSettings({
            ...pageSettings,
            total: response.data.count
        })
    })
    }

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, userData])

  const handleChange = (pagination, filters, sorter) =>{
      let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
      setPageSettings(pageData)
  }

 
  const columns = [
    {
      title: "Name",
      dataIndex: "asset__name",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          <a className="avatar">
            <Image 
              src={record?.asset?.image} 
              type="object" 
              style={{ 
                width: "40px", 
                height: "40px", 
                objectFit: "contain", 
                borderRadius: "4px" 
              }}
            />
          </a>
          <div>
            <a className="profile-split d-flex flex-column">
              {record?.asset.name} 
            </a>
            <small className="table-avatar">
              {record?.asset.class_code}
            </small>
          </div>
        </h2>
      )       
    },
    {
      title: "Description",
      dataIndex: "description",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
          <span >{record?.asset?.description}</span>  
        </div>
      )   
    },
    {
      title: "Brand",
      dataIndex: "brand",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
          <span className={`badge badge-soft-warning`}>{record?.asset?.brand}</span>  
        </div>
      )   
    },
    {
      title: "Serial No",
      dataIndex: "serial_number",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record?.asset?.serial_number}
        </span>
      )   
    },
    {
      title: "FA No",
      dataIndex: "ext_id",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {record?.asset?.ext_id}
        </span>
      )   
    },
    {
      title: "Current Value",
      dataIndex: "current_value",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">{record?.asset?.current_value}</span>
      )
    },
    // {
    //   title: "Current Owner",
    //   dataIndex: "current_user",
    //   sorter: true,
    //   render: (text, record) => (
    //     <h2 className="table-avatar d-flex">
    //       <a className="avatar">
    //         <Image 
    //           src={record?.company_user?.profile_image} 
    //           type="object"
    //         />
    //       </a>
    //       <div>
    //         <a className="profile-split d-flex flex-column">
    //           {record?.company_user?.first_name} {record?.company_user?.last_name} 
    //         </a>
    //         <small className="table-avatar">
    //           {record?.company_user?.emp_no}
    //         </small>
    //       </div>
    //     </h2>
    //   )   
    // },
    // {
    //   title: "Purchase Date",
    //   dataIndex: "purchase_date",
    //   sorter: true,
    //   align: "center",
    //   render: (text, record) => (
    //     <>{formatDateHandler2(record?.asset?.purchase_date) || "-"}</>
    //   ),
    // },
    // {
    //   title: "Purchase Value",
    //   dataIndex: "purchase_value",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record?.asset?.purchase_value}
    //     </span>
    //   )   
    // },
    
    {
      title: "Assigned Date",
      dataIndex: "issue_date",
      sorter: true,
      render: (text, record) => (
        <>{formatDateHandler2(record?.issue_date) || "-"}</>
      ),
    },
    {
      title: "Return Date",
      dataIndex: "return_date",
      sorter: true,
      render: (text, record) => (
        <>{formatDateHandler2(record?.return_date) || "-"}</>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: true,
      render: (text, record) => (
        <>
        {record?.asset?.status ? <span className="badge badge-soft-success">Assigned</span> : <span className="badge badge-soft-danger">Unassigned</span>}
        </>
      ),
    },
  ];

  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })
  }

  // const handleAssetDetailPage = (id, index) => {		
  //   // console.log(id, "----ASSET ID----")	
  //   // return					  
  //    navigate(`/assets/${id}`)
  //   //  setSelectedPage(index)
  //  }

   
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {assets.map((asset, index) => (
            <div
              className="col-md-6 col-sm-12 col-lg-6 col-xl-4 col-xxl-3"
              key={asset.id}
            >
              <div className="profile-widget">
                <div className="dropdown profile-action">
                  <a>
                    <i className="la la-edit"></i>
                  </a>
                </div>
                <div className="row">
                  <div className="col-4">
                    <div className="profile-img">
                      <a className="avatar">
                        <Image 
                          src={asset?.asset?.image} 
                          type="user" 
                          alt="Asset Image" 
                          style={{ 
                            width: "100%", 
                            height: "100%", 
                            objectFit: "contain", 
                            borderRadius: "4px" 
                          }} 
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-8">
                    <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                      <a>
                        {asset?.asset?.name}
                      </a>
                      <span>{asset?.asset?.class_code}</span>
                    </h4>
                    <div className="small text-muted text-start">
                      <strong>Description:</strong> <span >{asset?.asset?.description}</span>
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Brand:</strong> <span className="badge badge-soft-warning">{asset?.asset?.brand}</span>
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Serial #:</strong> {asset?.asset?.serial_number}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Current Value :</strong> {asset?.asset?.current_value}
                    </div>
                    {/* <div className="small text-muted text-start">
                      <strong>Current Owner:</strong> {asset?.company_user ? 
                        `${asset?.company_user?.first_name} ${asset?.company_user?.last_name} (${asset?.company_user?.emp_no})` 
                        : "N/A"}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Purchase Date:</strong> {formatDateHandler2(asset?.asset?.purchase_date) || "-"}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Purchase Value:</strong> {asset?.asset?.purchase_value}
                    </div> */}
                    <div className="small text-muted text-start">
                      <strong>FA No:</strong> {asset?.asset?.ext_id}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Assigned Date:</strong> {formatDateHandler2(asset?.issue_date) || "-"}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Return Date:</strong> {formatDateHandler2(asset?.return_date) || "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  return (
    <>

{
  isMobile ?
  <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
  :
  <div className="table-responsive ">
  <Table
  // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
    columns={columns}
    dataSource={assets}
    className="table-striped"
    loading={loading}
    pagination={{
        total: pageSettings?.total,
        pageSize: pageSettings?.pageSize,
        showSizeChanger: true,
        pageSizeOptions: pageSizeOptions,
        // showQuickJumper: true,
        itemRender: itemRender,
        position:"right",
        current:pageSettings?.page,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    }}
    onChange={handleChange}

/>
  </div>

}
        
   

    </>
  );
};


export default Assets